import { Component, Input, OnInit } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { AddHallpassComponent } from "../../../shared/manual-sidebar/hallpass-menu/add-hallpass/add-hallpass.component";
import { ConfirmationService } from "primeng/api";
import { UpdateHallpassComponent } from "../../../shared/manual-sidebar/hallpass-menu/update-hallpass/update-hallpass.component";
import { ScanPointManualAddHallPassComponent } from "./scan-point-manual-add-hall-pass/scan-point-manual-add-hall-pass.component";
import { ScanPointManualUpdateHallPassComponent } from "./scan-point-manual-update-hall-pass/scan-point-manual-update-hall-pass.component";

@Component({
	selector: "caass-scan-point-manual-hall-pass",
	templateUrl: "./scan-point-manual-hall-pass.component.html",
	styleUrls: ["./scan-point-manual-hall-pass.component.css"],
})
export class ScanPointManualHallPassComponent implements OnInit {
	constructor(private scanService: TimeScanningService, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadHallpassData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	AudienceMode: any = "Student";
	@Input() FacilityID: any;
	@Input() FacilityLocationID: any;
	@Input() Receipt_IDPrinterID: any;
	@Input() SelectedPerson: any;

	lstHallpasses: any = [];
	SelectedEntry: any = null;
	cols: any = [
		{ field: "HallpassDateDesc", header: "Date" },
		{ field: "StartTimeDesc", header: "Time" },
		{ field: "HallpassReasonDesc", header: "Status" },
	];
	pagefirst: Number = 0;
	pagerows: Number = 5;

	errorMessage: any = "";
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////
	loadHallpassData() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var result = this.scanService.HallPassInfoGetList(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstHallpasses = response;
			},
			(error) => {}
		);
	}
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		var fName: string = this.SelectedPerson.FirstName + " " + this.SelectedPerson.LastName;
		fName = fName.trim();

		//Create Popup
		var ref = this.dialogService.open(ScanPointManualAddHallPassComponent, {
			header: "Add Hall Pass",
			width: "fit-content",
			data: {
				PersonID: this.SelectedPerson.PersonID,
				PersonName: fName,
				DesignatorID: this.SelectedPerson.ID,

				SelectedFacilityID: this.FacilityID,
				SelectedFacilityLocationID: this.FacilityLocationID,
				SelectedPrinterID: this.Receipt_IDPrinterID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHallpassData();
			}
		});
	}

	onView() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedEntry.HallpassID < 0) {
			this.errorMessage = "Select a Hallpass to View";
			return;
		}

		var fName: string = this.SelectedPerson.FirstName + " " + this.SelectedPerson.LastName;
		fName = fName.trim();

		//Create Popup
		var ref = this.dialogService.open(ScanPointManualUpdateHallPassComponent, {
			header: "View Hall Pass",
			width: "fit-content",
			data: {
				SelectedHallPass: this.SelectedEntry,
				PersonID: this.SelectedPerson.PersonID,
				PersonName: fName,
				DesignatorID: this.SelectedPerson.ID,

				SelectedFacilityID: this.FacilityID,
				SelectedFacilityLocationID: this.FacilityLocationID,
				SelectedPrinterID: this.Receipt_IDPrinterID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHallpassData();
				this.SelectedEntry = {
					HallpassID: -1,
				};
			}
		});
	}

	onReprint() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedEntry.HallpassID < 0) {
			this.errorMessage = "Select a Hallpass to Reprint";
			return;
		}

		var result = this.scanService.HallPassReprint(this.SelectedEntry.HallpassID, this.Receipt_IDPrinterID);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "hallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Hall Pass was successfully Reprinted",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SelectedEntry = {
								HallpassID: -1,
							};
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "hallpass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Reprint the Hall Pass",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.SelectedEntry = {
								HallpassID: -1,
							};
						},
					});
				}
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	//////////////////////////////////////////
}
